// Package Imports
import { toJS } from "mobx";

// Package Imports
import axios from "utils/axios"
import * as APITypes from "constants/API"
import NeedTypeEnum from "../../../../constants/NeedTypeEnum";
import OptimizationStore from "../../store/OptimizationStore";
import AuthStore from "../../../login/store/AuthStore";
import { EMPLOYER_EMPLOYEE_SCHEME_B, MWP_ACT } from 'constants/ CustomerType';

const generateAddAssuredDataStructure = async (data, needType) => {
  let productListData = toJS(OptimizationStore.product_list_data);
  const journeyData = toJS(AuthStore.journeyData);
  let { family_details_list, journey_details } = journeyData;

  let laDetails = family_details_list.find(
    (familyData) => familyData.id === data.family_member_id
  );

  let secondaryLaDetails = family_details_list.find(
    (familyData) => familyData.id === data.secondary_la
  );
  let riskList = [];
  let productWiseRiskList = [];
  let allFamilyProductIds = []
  let showSingleMember = AuthStore.journeyTypeName === EMPLOYER_EMPLOYEE_SCHEME_B || AuthStore.journeyTypeName === MWP_ACT
  if (journey_details.high_risk_selected) riskList.push("high");
  riskList = [...riskList, ...["medium", "low"]];
  riskList.forEach((item) => {
    productWiseRiskList.push({
      risk: item,
      BI: {},
      bi_request: {},
      update_BI: false,
    });
  });

  let selectedNeedIndex = productListData.findIndex(
    (item) => item.need_unique_name === needType
  );
  if (selectedNeedIndex !== -1) {
    let selectedProduct = productListData[selectedNeedIndex];
    if (selectedProduct.data && selectedProduct.data.length > 0) {
      let details = {
        BI:
          needType === NeedTypeEnum.PROTECTION_FOR_MY_FAMILY
            ? { risk: "high", BI: {}, bi_request: {}, update_BI: false }
            : productWiseRiskList,
        dob: laDetails.dob,
        family_member_type: laDetails.family_member_type,
        gender: laDetails.gender,
        id: laDetails.id,
        income_type: laDetails.income_type,
        isSelected: true,
        monthly_income: laDetails.monthly_income,
        payout_mode: data.payout_mode,
        life_assured_details: laDetails,
        secondary_la_Details: secondaryLaDetails,
        proposer_details: {},
        productDisabled: false
      };
      if(showSingleMember) {
        selectedProduct.data.forEach((product) => {
          product.productDisabled = true;
          allFamilyProductIds.push(product.family_product_id)
        })
      }
      selectedProduct.data.splice(0, 0, details);
    }
  }
  if(showSingleMember) {
    allFamilyProductIds.forEach( async (productId) => {
      await axios.post(APITypes.REMOVE_LA, {"family_product_id" : productId})
    })
  }
  OptimizationStore.product_list_data = [...productListData];
};

export default generateAddAssuredDataStructure;
